export default __webpack_public_path__ + "static/media/frame1-desktop.112cd70c.jpg";